import {useEffect} from 'react';
import {Provider} from 'react-redux';
import * as Sentry from '@sentry/react';
import Container from '@frontend/ui-kit/Components/Container';
import Loader from './Components/shared/Loader';
import {setIsBrowserTabActive, setIsOnline} from './slices/shared';
import store from './store';
import Router from './Router';

const App = () => {
    useEffect(() => {
        const handleNetworkConnection = () => {
            store.dispatch(setIsOnline(navigator.onLine));
        };

        window.addEventListener('online', handleNetworkConnection);
        window.addEventListener('offline', handleNetworkConnection);

        return () => {
            window.removeEventListener('online', handleNetworkConnection);
            window.removeEventListener('offline', handleNetworkConnection);
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            store.dispatch(setIsBrowserTabActive(!document.hidden));
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const onBeforeCapture = (scope: Sentry.Scope) => {
        scope.setLevel('fatal');
    };

    return (
        <Sentry.ErrorBoundary beforeCapture={onBeforeCapture}>
            <Provider store={store}>
                <Loader/>

                <Container fluid>
                    <Router/>
                </Container>
            </Provider>
        </Sentry.ErrorBoundary>
    );
};

export default App;
